import { FC } from 'react';
import classNames from 'classnames';
import styles from './../index.module.scss';
import { Title } from './title/index';
import { Underline } from './underline';
import { Paragraph } from './paragraph/index';
interface Params {
  children?: any;
  bold?: boolean;
}
export const Third: FC<Params> = (props) => {
  return (
    <div className={classNames(styles.title, props.bold ? styles.bold : '')}>
      <div className={styles.privacyName}>小程序与第三方共享信息清单</div>
      <Title bold>腾讯地图SDK</Title>
      <Paragraph>
        涉及个人信息：<b>位置信息（经纬度、精确位置、粗略位置）</b>
      </Paragraph>
      <Paragraph>使用目的：获取用户位置的附近门店</Paragraph>
      <Paragraph>使用场景：点餐页选餐、选择门店、导航到店</Paragraph>
      <Paragraph>权限调用：获取用户位置信息</Paragraph>
      <Paragraph>合作方主体：深圳市腾讯计算机系统有限公司</Paragraph>
      <Paragraph>收集方式：用户主动授权</Paragraph>
      <Paragraph>官方链接：https://map.qq.com/</Paragraph>
      <Paragraph>合作方隐私政策链接：</Paragraph>
      <Paragraph>
        {/* <a
          href="https://privacy.qq.com/document/preview/29cd78d3d9da4da2b340bedb2d186612/v_20230407163053"
          rel="noreferrer"
        >
          https://privacy.qq.com/document/preview/29cd78d3d9da4da2b340bedb2d186612/v_20230407163053
        </a> */}
        https://privacy.qq.com/document/preview/29cd78d3d9da4da2b340bedb2d186612/v_20230407163053
      </Paragraph>
      <Title bold>微信滑块SDK</Title>
      <Paragraph>涉及个人信息：无</Paragraph>
      <Paragraph>使用目的：保护账号安全</Paragraph>
      <Paragraph>使用场景：人工认证,防止机器人操作</Paragraph>
      <Paragraph>权限调用：无</Paragraph>
      <Paragraph>合作方主体：深圳市腾讯计算机有限公司</Paragraph>
      <Paragraph>收集方式：无</Paragraph>
      <Paragraph>合作方隐私政策链接：</Paragraph>
      <Paragraph>
        {/* <a
          href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy"
          rel="noreferrer"
        >
          https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy
        </a> */}
        https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy
      </Paragraph>
      <Title bold>第三方合作商：</Title>
      <Paragraph bold>配送服务</Paragraph>
      <Paragraph>
        <b>第三方公司名称：</b>北京麦芽田网络科技有限公司
      </Paragraph>
      <Paragraph>
        <b>产品名称：</b>麦芽田聚合配送
      </Paragraph>
      <Paragraph>
        <b>
          共享信息名称：<Underline>精准位置信息</Underline>
        </b>
        、姓名、<Underline>手机号、地址、支付方式</Underline>、物流信息、
        <Underline>交易金额、下单时间、订单编号、支付状态</Underline>
      </Paragraph>
      <Paragraph>
        <b>使用目的：</b>完成订单配送流程
      </Paragraph>
      <Paragraph>
        <b>使用场景：</b>用户下单完成将订单推送到第三方，由第三方完成配送；
      </Paragraph>
      <Paragraph>
        <b>共享方式：</b>后台接口传输
      </Paragraph>
    </div>
  );
};
